import React, { useState } from 'react'
import { useContext } from 'react'
import { addcontext } from '../../ContextShare/ContextShare'
import { SeqNumberChangeBs } from '../../Services/allApi'
import { toast, ToastContainer } from 'react-toastify'

function SeqChangeBs() {
    const { changeSeqNoBS, setChangeSeqNoBS } = useContext(addcontext)
    const [data, setData] = useState({
        video_id: null,
        after_video_id: null
    })
    const handleChangeSeqNo = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await SeqNumberChangeBs(data, reqHeader)
        console.log(result);
        if (result.status == 200) {
            toast.success('Sequence changin successfull')
            setTimeout(() => {
                setChangeSeqNoBS(false)
            }, 1500)
        }
        else {
            const messageData = result?.response?.data?.message;
            // Check if messageData is an object
            const errorMessage = typeof messageData === 'object' && messageData !== null
                ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
                : messageData; // If it's a string, use it directly
            toast.error(errorMessage ?? "There was a problem adding kla");
        }
    }
    return (
        <>
            <div className='w-full flex items-center flex-col'>
                <h3 className='text-blue-700 text-xl font-bold mt-20 mb-4 text-center'>Enter Details</h3>
                <div className='flex flex-row justify-center flex-wrap mb-10 ms-5 me-5 gap-5 w-full'>
                    <div className='w-2/12 flex flex-col  mb-5 mt-5'>
                        <label htmlFor="date" className='text-sm'>Video ID</label>
                        <input
                            id='date'
                            value={data.video_id}
                            onChange={(e) => setData({ ...data, video_id: Number(e.target.value) })}
                            type="text"
                            className='dateinput w-full '
                            style={{
                                border: '1px solid #384D6C', height: '2.3rem',
                                borderRadius: '0.3rem',
                            }}
                        />
                    </div>

                    <div className='w-2/12 flex flex-col  mb-5 mt-5'>
                        <label htmlFor="date" className='text-sm'> Insert after sequence number</label>
                        <input
                            value={data.after_video_id}
                            onChange={(e) => setData({ ...data, after_video_id: Number(e.target.value) })}
                            type="text"
                            className='dateinput w-full '
                            style={{
                                border: '1px solid #384D6C', height: '2.3rem',
                                borderRadius: '0.3rem',
                            }}
                        />
                    </div>

                </div>
                <br />
                <div className='w-2/12'>
                    <button className='w-full py-2 bg-primary text-white rounded-full' onClick={handleChangeSeqNo}>Save Changes</button>
                </div>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    )
}


export default SeqChangeBs